import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/glue-ui/block';
import { EditableText, EditableImg } from '@smartfire/components';
import { Button } from 'src/components/Button';
import { Inspector } from './inspector';
import clsx from 'clsx';
import style from './style.module.scss';

interface EngagementsBlockProps {
    linkMore: string;
    isCurrent: boolean;
    defineAsCurrent: () => void;
}

const EngagementsBlock: React.FC<EngagementsBlockProps> = ({ linkMore, isCurrent, defineAsCurrent }) => {
    useInspectorControl(Inspector, []);
    const { isEditing } = useEditor();

    return (
        <BlockWrapper.Article
            className={clsx(style.engagement, isCurrent && style.isCurrent, isEditing && style.admin)}
        >
            <section className={style.heading} onClick={defineAsCurrent}>
                <EditableImg smartProp="image" className={style.image} />
                <EditableText smartProp="title" placeholder="Titre" className={style.title} tagName="h3" />
            </section>
            <section className={style.content}>
                <EditableText smartProp="description" placeholder="Description" className={style.description} />
                {linkMore && (
                    <Button href={!isEditing ? linkMore : undefined} className={style.button} showArrow={true}>
                        En savoir plus
                    </Button>
                )}
            </section>
        </BlockWrapper.Article>
    );
};

export default defineBlock({
    //@ts-ignore
    Block: EngagementsBlock,
    smartProps: {
        image: smartProps.image,
        title: smartProps.string.withDefault(''),
        description: smartProps.string.withDefault(''),
        linkMore: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Engagement',
        parent: ['smartfire/engagements-tabs'],
    },
});
